module.exports = __webpack_public_path__ + "static/media/pic4.f9864c23.jpg";